import React from 'react';
import './LawnPackageone.css';
import { Link } from 'react-router-dom';

const LawnPackageone = () => {
  return (
    <div className="LawnPackageone-section">
      <h2 className="LawnPackageone-title"> Need Your HOA's Lawns Restored?</h2>

      <p className="LawnPackageone-subtitle">
       If your HOA landscaping is not properly maintained, our Lawn Recovery Package can restore your property to its optimal condition. However, a cleanup or redesign may be needed first — 'lawn recovery' is essentially just a fancy way of saying re-seeding a lawn.
      </p>

   <Link to="/Landscapingdesign" className="LawnPackageone-button">
  {/* <FaPhoneAlt className="LawnPackageone-icon" /> */}
  Check Packages
</Link>
    </div>
  );
};

export default LawnPackageone;
